import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setDoctorTabs } from "../redux/actions/doctorTabsAction";
import { setBranchTabs } from "../redux/actions/branchTabsAction"; // Действие для вкладок филиалов
import _ from "lodash";
import { useHorizontalScroll } from "../global/hooks/useHorizontalScroll";

const DoctorTab = ({ doctors, specialities, branches }) => {
  const dispatch = useDispatch();
  const scrollRef = useHorizontalScroll();

  // Устанавливаем вкладку для врачей
  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSpecialityId = parseInt(
      urlParams.get("specialityId") &&
        urlParams.get("specialityId").replace(/"/g, "")
    );
    const urlSpeciality = specialities.find((speciality) => {
      return speciality.Id === urlSpecialityId;
    });
    urlSpeciality && dispatch(setDoctorTabs(urlSpeciality.Name));
  }, 400);

  // Обработчик для вкладок врачей
  const setDoctorTabHandler = (e) => {
    dispatch(setDoctorTabs(e.target.value.toLowerCase()));
  };

  // Обработчик для вкладок филиалов
  const setBranchTabHandler = (e) => {
    document
      .querySelectorAll(".choose-master-root__tabs.branch .btn")
      .forEach(function (elem) {
        elem.classList.remove("active");
      });
    e.target.classList.add("active");
    dispatch(setBranchTabs(e.target.value));
  };

  const doctorTab = useSelector(
    (s) => s.doctorTabsReducer.doctorTab
  ).toLowerCase();

  const branchTab = useSelector(
    (s) => s.branchTabsReducer.branchTab
  ).toLowerCase(); // Вкладка для филиалов

  // Уникальные специальности
  const filtredSpecialities = _.uniqWith(
    doctors.reduce((acc, rec) => {
      return [
        ...acc,
        {
          SpecialityName: rec.SpecialityName,
          IdSpeciality: rec.IdSpeciality,
        },
      ];
    }, []),
    _.isEqual
  );

  // Преобразуем данные о филиалах в подходящий формат для табов
  const filtredBranches =
    branches.map((branch) => ({
      Name: branch.Name,
    })) || [];

  return (
    <div className="choose-master-root">
      {/* Таб для врачей */}
      <div
        className="choose-master-root__tabs Specialities"
        style={{ overflow: "auto" }}
        ref={scrollRef}
      >
        <Link to={"/"}>
          <button
            className={`${
              doctorTab === "все" ? "active" : ""
            } btn choose-master-root__tab`}
            onClick={setDoctorTabHandler}
            value={"все"}
          >
            Все
          </button>
        </Link>
        {filtredSpecialities.map((doctor, idx) => {
          return (
            <Link to={`/`} key={idx}>
              <button
                className={`${
                  doctorTab === doctor.SpecialityName.toLowerCase()
                    ? "active"
                    : ""
                } btn choose-master-root__tab`}
                onClick={setDoctorTabHandler}
                value={doctor.SpecialityName}
                id={doctor.IdSpeciality}
              >
                {doctor.SpecialityName}
              </button>
            </Link>
          );
        })}
      </div>

      {/* Таб для филиалов */}
      {/* <div
        className="choose-master-root__tabs branch"
        style={{ overflow: "auto" }}
        ref={scrollRef}
      >
        <Link to={"/"}>
          <button
            className={`${
              branchTab === "все" ? "active" : ""
            } btn choose-master-root__tab`}
            onClick={setBranchTabHandler}
            value={"все"}
          >
            Все
          </button>
        </Link>
        {filtredBranches.map((branch, idx) => {
          return (
            <Link to={`/`} key={idx}>
              <button
                className={`${
                  branchTab === branch.Name.toLowerCase() ? "active" : ""
                } btn choose-master-root__tab`}
                onClick={setBranchTabHandler}
                value={branch.Name}
              >
                {branch.Name}
              </button>
            </Link>
          );
        })}
      </div> */}
    </div>
  );
};

export default DoctorTab;
